import { withViewModel } from '../../../../../../infrastructure/components/with-view-model';
import { ConnectionGroupFormPresentation } from './connection-group-form.presentation';
import { ConnectionGroupFormVM } from './connection-group-form.viewmodel';
import { IConnectionDetailsDTO, IConnectionGroupDTO } from '../../../../../../api/connections.dao';

type ConnectionGroupFormProps = {
    group?: IConnectionGroupDTO;
    connections: IConnectionDetailsDTO[];
    contextParams: { meetingId?: number; roomId?: number };
    formSubmitAction: (connectionGroup: IConnectionGroupDTO) => Promise<IConnectionGroupDTO>;
    deleteConnectionGroup: (groupId: number) => void;
};

export const ConnectionGroupForm = withViewModel(ConnectionGroupFormPresentation, (props: ConnectionGroupFormProps) => {
    const {
        group,
        connections,
        contextParams,
        formSubmitAction,
        deleteConnectionGroup,
    } = props;
    const vm = new ConnectionGroupFormVM(
        group,
        connections,
        contextParams,
        formSubmitAction,
        deleteConnectionGroup
    );

    return vm;
}, () => [], vm => {
    vm.onUnmount();
});
